var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.scanQrCode}},[_c('v-icon',[_vm._v("qr_code_scanner")]),_vm._v(" Scan QRCode")],1)}
var staticRenderFns = []

export { render, staticRenderFns }